<ui-svg-icon
    icon="user"
    style="font-size: 10rem;">
</ui-svg-icon>
